import { render, staticRenderFns } from "./CategoryStylePage.vue?vue&type=template&id=52813509&scoped=true&"
import script from "./CategoryStylePage.vue?vue&type=script&lang=js&"
export * from "./CategoryStylePage.vue?vue&type=script&lang=js&"
import style0 from "./CategoryStylePage.vue?vue&type=style&index=0&id=52813509&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52813509",
  null
  
)

export default component.exports